module.exports = __webpack_public_path__ + "assets/img/展厅全貌GIF动图.465f3ff0.gif";